<template>
  <div>
    <table class="table" v-if="!vertical">
      <thead>
        <tr>
          <th v-for="header in headers" :key="header.value">
            {{header.text}}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <td v-for="(header) in headers" :key="header.value">
            {{item[header.value]}}
          </td>
        </tr>
      </tbody>
    </table>

    <table class="table" v-if="vertical">
      <tr v-for="header in headers" :key="header.value">
        <th>
          {{header.text}}
        </th>
        <td style="width: 85%"  v-for="(item, index) in items" :key="index">
          {{item[header.value]}}
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    vertical: {
      type: Boolean,
      default: false,
    },
    headers: {
      type: Array,
    },
    items: {
      type: Array,
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  width: 100%;
  text-align: center;
  border-collapse: collapse;
  border: 1px solid #c4d0ce;

  th {
    background-color: #007960;
    color: #FFF;
    font-weight: normal;
    padding: 10px;
    border-left: 1px solid #c4d0ce;
  }

  td {
    padding: 10px;
    border-left: 1px solid #e8e8e8;
  }

  tr:nth-child(odd) {
    background-color: #f6f6f6;
  }
}
</style>
